import React, { useEffect, useRef } from "react";
import {
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonIcon,
  IonTitle,
  IonToolbar
} from "@ionic/react";
import { ScreenOrientation } from "@capacitor/screen-orientation";
import { Capacitor } from "@capacitor/core";
import { arrowBack } from "ionicons/icons";

declare global {
  interface Window {
    TradingView: any;
  }
}

interface TradingViewChartProps {
  symbol: string;
  interval: string;
  onDismiss?: () => void;
}

const TradingViewChart: React.FC<TradingViewChartProps> = ({
  symbol,
  interval,
  onDismiss
}) => {
  const widgetRef = useRef();

  useEffect(() => {
    // Ensure TradingView is available
    if (!window.TradingView) {
      console.error("TradingView is undefined");
      return;
    }

    const widget = new window.TradingView.widget({
      container_id: "tradingview_widget",
      studies: ["RSI@tv-basicstudies"],
      symbol: `BINANCE:${symbol}`,
      interval: interval?.replace("m", "") || "15",
      timezone: "Etc/UTC",
      theme: "dark",
      style: "1",
      toolbar_bg: "#0b0628",
      enable_publishing: false,
      hide_top_toolbar: true,
      save_image: false
    });

    return () => {
      // check if widget container still exists before calling widget.remove()
      if (widget && document.getElementById("tradingview_widget")) {
        widget.remove();
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (Capacitor.isNative) {
      try {
        ScreenOrientation.lock({
          orientation: "landscape"
        });

        return () => {
          ScreenOrientation.unlock();
        };
      } catch (error) {
        console.warn("Error with ScreenOrientation:", error);
      }
    } else {
      console.warn("Not running on a Capacitor native platform");
    }
  }, []);

  return (
    <>
      <IonHeader>
        <IonToolbar>
          <IonTitle>Technical Analysis</IonTitle>
          <IonButtons slot="start">
            <IonButton onClick={onDismiss}>
              <IonIcon slot="icon-only" icon={arrowBack} />
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <div
          id="tradingview_widget"
          // @ts-ignore
          ref={widgetRef}
          style={{ width: "100%" }}
        />{" "}
      </IonContent>
    </>
  );
};

export default TradingViewChart;
